import { render } from "./HjpTabView.vue?vue&type=template&id=fdf38798&ts=true"
import script from "./HjpTabView.vue?vue&type=script&lang=ts"
export * from "./HjpTabView.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/ecosystem/web-hrd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__